import { BadgeCheck } from "lucide-react";

export default function VerifiedBadge({ show, compact = false, testid }) {
  if (!show) return null;
  if (compact) {
    return (
      <span data-testid={testid} title="Geverifieerd door Fetshop" className="flex items-center gap-1 rounded-full bg-sky-500/90 text-white text-[10px] font-semibold uppercase tracking-wider whitespace-nowrap px-2 py-1 shadow-lg shadow-sky-950/40">
        <BadgeCheck className="h-3 w-3" /> Geverifieerd
      </span>
    );
  }
  return (
    <span data-testid={testid} title="Deze aanbieder is gecontroleerd door Fetshop" className="inline-flex items-center gap-1 rounded-full border border-sky-500/50 bg-sky-500/15 text-sky-300 text-xs font-medium px-2 py-0.5">
      <BadgeCheck className="h-3.5 w-3.5" /> Geverifieerd
    </span>
  );
}
